// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2maE1","row":"ProcedureTreatmentSummary_row__HtwQ0"};